/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UsageUpdatedMessage } from '../../models/usage-updated-message';

export interface GetnotificationsUsageUpdatedSchema$Params {
}

export function getnotificationsUsageUpdatedSchema(http: HttpClient, rootUrl: string, params?: GetnotificationsUsageUpdatedSchema$Params, context?: HttpContext): Observable<StrictHttpResponse<UsageUpdatedMessage>> {
  const rb = new RequestBuilder(rootUrl, getnotificationsUsageUpdatedSchema.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UsageUpdatedMessage>;
    })
  );
}

getnotificationsUsageUpdatedSchema.PATH = '/api/hubs/notifications/UsageUpdated';
